if (!customElements.get('asp-dsat-chooser')) customElements.define('asp-dsat-chooser', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) {
      if (this.observer) this.observer.observe(this.addButton);
      if (this.onPop) window.addEventListener('popstate', this.onPop);
      return;
    }
    this.ready = true;
    try {
      this.copy = JSON.parse(this.querySelector('[data-asp-ui]').textContent);
      this.products = JSON.parse(this.querySelector('[data-asp-products]').textContent);
      this.metadata = JSON.parse(this.querySelector('[data-asp-metadata]').textContent);
      this.contents = JSON.parse(this.querySelector('[data-asp-content-data]').textContent);
      this.variants = new Map();
      this.products.forEach(p => p.variants.forEach(v => this.variants.set(v.id, {...v, product:p})));
      this.options = this.metadata.filter(x => this.variants.has(x.id));
      this.path = 'year'; this.year = ''; this.month = ''; this.selected = null;
      this.yearSelect = this.querySelector('[data-asp-year]');
      this.choiceField = this.querySelector('[data-asp-choice-field]');
      this.choiceList = this.querySelector('[data-asp-choice-list]');
      this.yearButtons = this.querySelector('[data-asp-year-buttons]');
      this.addButton = this.querySelector('[data-asp-add]');
      this.form = this.querySelector('.asp-dsat__form');
      this.sticky = this.querySelector('[data-asp-sticky]');
      this.querySelectorAll('[data-asp-path]').forEach(b => b.addEventListener('click', () => {
        if (this.path === b.dataset.aspPath) return;
        this.path = b.dataset.aspPath; this.year = ''; this.month = '';
        this.selected = this.path === 'complete' ? this.options.find(x => x.kind === 'complete' && !x.alias) : null;
        this.render(true);
      }));
      this.yearSelect.addEventListener('change', () => {
        this.year = this.yearSelect.value; this.month = '';
        this.selected = this.candidates().find(x => String(x.year) === this.year) || null;
        this.render(true);
      });
      this.yearButtons.addEventListener('click', e => {
        const button = e.target.closest('[data-choice-year]');
        if (!button) return;
        this.year = button.dataset.choiceYear; this.month = ''; this.selected = null;
        this.render(true);
      });
      this.choiceList.addEventListener('change', e => {
        if (!e.target.matches('[data-choice-id]')) return;
        this.selected = this.options.find(x => x.id === e.target.value) || null;
        this.year = String(this.selected?.year || ''); this.month = String(this.selected?.month || '');
        this.render(true);
      });
      this.form.addEventListener('submit', e => {
        const v = this.selected && this.variants.get(this.selected.id);
        if (!v || !v.available) { e.preventDefault(); this.showError(this.copy.choose_package); }
      });
      this.observer = new IntersectionObserver(entries => { this.mainVisible = entries[0].isIntersecting; this.updateSticky(); }, {threshold:0});
      this.observer.observe(this.addButton);
      this.onPop = () => this.restore();
      window.addEventListener('popstate', this.onPop);
      this.restore();
      this.querySelector('[data-asp-native-fallback]').hidden = true;
    } catch (error) {
      this.querySelector('[data-asp-error]').hidden = false;
      this.querySelector('[data-asp-error]').textContent = this.querySelector('[data-asp-fallback-copy]').textContent;
      this.querySelector('[data-asp-native-fallback]').hidden = false;
    }
  }
  disconnectedCallback() { this.observer?.disconnect(); window.removeEventListener('popstate', this.onPop); }
  candidates() { return this.options.filter(x => x.kind === this.path && !x.alias); }
  currency(value) {
    try { return new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency', currency:this.dataset.currency || 'USD', maximumFractionDigits:value % 100 ? 2 : 0}).format(value / 100); }
    catch (e) { return String(value / 100); }
  }
  label(option) { return this.contents[option.id]?.label || option.label || this.variants.get(option.id)?.title || ''; }
  listLabel(option) {
    if (option.kind === 'monthly') return option.year + ' ' + new Intl.DateTimeFormat(this.dataset.locale || 'en', {month:'long', timeZone:'UTC'}).format(new Date(Date.UTC(option.year, option.month - 1, 1)));
    return this.label(option).replace(/^([A-Za-z]+) (20\d{2})/, '$2 $1');
  }
  fill(select, items, placeholder, value) {
    select.replaceChildren(new Option(placeholder, ''));
    items.forEach(x => select.add(new Option(x.label, x.value)));
    select.value = value || '';
  }
  restore() {
    const requested = new URL(location.href).searchParams.get('variant');
    const requestedMatch = this.options.find(x => x.id === requested);
    const match = requestedMatch?.replacement_id ? this.options.find(x => x.id === requestedMatch.replacement_id) : requestedMatch;
    if (match) { this.path = match.kind; this.year = String(match.year || ''); this.month = String(match.month || ''); this.selected = match; }
    else { this.path = 'year'; this.year = ''; this.month = ''; this.selected = null; }
    this.render(!!requestedMatch?.replacement_id);
    if (requested && !match) this.showError(this.copy.invalid_variant);
  }
  renderChoices(candidates, years) {
    this.querySelector('[data-asp-single-years]').hidden = this.path !== 'single';
    const yearKey = years.join(',');
    if (this.yearButtons.dataset.years !== yearKey) {
      this.yearButtons.replaceChildren();
      years.forEach(year => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.choiceYear = String(year); button.textContent = String(year);
        this.yearButtons.append(button);
      });
      this.yearButtons.dataset.years = yearKey;
    }
    this.yearButtons.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.choiceYear === this.year)));
    const visible = this.path === 'monthly' || (this.path === 'single' && !!this.year);
    this.choiceField.hidden = !visible;
    if (!visible) return;
    const choices = candidates.filter(x => this.path === 'monthly' || String(x.year) === this.year).sort((a,b) => b.year - a.year || a.month - b.month || this.label(a).localeCompare(this.label(b), this.dataset.locale || 'en', {numeric:true}));
    this.choiceField.dataset.kind = this.path;
    this.querySelector('[data-asp-choice-heading]').textContent = this.path === 'monthly' ? this.copy.monthly_list_heading : this.year + ' — ' + this.copy.single_list_heading;
    this.querySelector('[data-asp-choice-count]').textContent = choices.length + ' ' + this.copy.choice_count;
    const choiceKey = choices.map(x => x.id).join(',');
    if (this.choiceList.dataset.choices !== choiceKey) {
      this.choiceList.replaceChildren();
      choices.forEach(option => {
        const variant = this.variants.get(option.id);
        const row = document.createElement('label'); row.className = 'asp-dsat__choice';
        const input = document.createElement('input');
        input.type = 'radio'; input.name = 'asp-choice-' + this.dataset.productId; input.value = option.id;
        input.dataset.choiceId = option.id; input.disabled = !variant.available;
        const name = document.createElement('span'); name.className = 'asp-dsat__choice-name'; name.textContent = this.listLabel(option);
        const price = document.createElement('span'); price.className = 'asp-dsat__choice-price'; price.textContent = variant.available ? this.currency(variant.price) : this.copy.unavailable;
        row.append(input, name, price); this.choiceList.append(row);
      });
      this.choiceList.dataset.choices = choiceKey;
      this.choiceList.scrollTop = 0;
    }
    this.choiceList.querySelectorAll('[data-choice-id]').forEach(input => {
      const option = choices.find(x => x.id === input.value);
      const aliasMatch = this.selected?.alias && this.selected.kind === option.kind && this.selected.year === option.year && this.selected.month === option.month;
      input.checked = this.selected?.id === input.value || !!aliasMatch;
      input.closest('label').classList.toggle('is-selected', input.checked);
    });
  }
  render(changeUrl) {
    const candidates = this.candidates();
    this.querySelector('[data-asp-error]').hidden = true;
    this.querySelectorAll('[data-asp-path]').forEach(b => {
      b.setAttribute('aria-pressed', String(b.dataset.aspPath === this.path));
      const prices = this.options.filter(x => x.kind === b.dataset.aspPath && !x.alias).map(x => this.variants.get(x.id)).filter(x => x.available).map(x => x.price);
      b.querySelector('[data-path-price]').textContent = prices.length ? (b.dataset.aspPath === 'complete' ? '' : this.copy.from + ' ') + this.currency(Math.min(...prices)) : this.copy.unavailable;
    });
    this.querySelector('[data-asp-hint]').textContent = this.copy[this.path + '_hint'];
    this.querySelector('.asp-dsat__filters').hidden = this.path !== 'year';
    const years = [...new Set(candidates.map(x => x.year).filter(Boolean))].sort((a,b) => b - a);
    if (this.path === 'year') this.fill(this.yearSelect, years.map(y => ({value:String(y), label:String(y) + ' — ' + this.currency(this.variants.get(candidates.find(x => x.year === y).id).price)})), this.copy.choose_year_placeholder, this.year);
    this.renderChoices(candidates, years);
    const selected = this.selected;
    const variant = selected && this.variants.get(selected.id);
    const detail = selected && this.contents[selected.id];
    this.querySelector('[data-asp-label]').textContent = selected ? this.label(selected) : this.copy.initial_prompt;
    this.querySelector('[data-asp-price]').textContent = variant ? variant.formattedPrice : '';
    this.querySelector('[data-asp-coverage]').textContent = detail?.coverage_note || selected?.coverage || (selected ? this.copy.selected_note : this.copy.initial_note);
    const input = this.querySelector('[data-asp-id]'); input.disabled = !variant?.available; input.value = variant?.id || '';
    const productInput = this.form.querySelector('[name="product-id"]'); if (productInput) productInput.value = variant?.product.id || this.dataset.productId;
    this.addButton.disabled = !variant?.available;
    this.addButton.textContent = variant ? (variant.available ? this.copy.add + ' — ' + this.currency(variant.price) : this.copy.unavailable) : this.copy.choose_package;
    const list = this.querySelector('[data-asp-items]'); list.replaceChildren();
    (detail?.items || [selected ? this.label(selected) : '']).filter(Boolean).forEach(text => { const li = document.createElement('li'); li.textContent = text; list.append(li); });
    this.querySelector('[data-asp-contents]').hidden = !selected;
    if (variant) {
      const img = this.querySelector('.asp-dsat__image');
      if (img.dataset.product !== variant.product.id) { img.src = variant.product.image; img.removeAttribute('srcset'); img.alt = variant.product.title; img.dataset.product = variant.product.id; }
    }
    if (changeUrl) {
      const url = new URL(location.href);
      if (variant) { url.pathname = variant.product.url; url.searchParams.set('variant', variant.id); }
      else url.searchParams.delete('variant');
      history.replaceState({}, '', url); this.querySelector('[data-asp-contents]').open = false;
    }
    this.updateSticky();
  }
  updateSticky() {
    const v = this.selected && this.variants.get(this.selected.id);
    this.sticky.hidden = !v?.available || this.mainVisible !== false;
    if (v) { this.querySelector('[data-asp-sticky-label]').textContent = this.label(this.selected); this.querySelector('[data-asp-sticky-price]').textContent = v.formattedPrice; this.querySelector('[data-asp-sticky-add]').disabled = !v.available; }
  }
  showError(text) { const e = this.querySelector('[data-asp-error]'); e.textContent = text; e.hidden = false; }
});
